import { Row, Col } from 'antd';

import Link from './Link';
import './Footer.css';

import img_wk_logo from '../assets/img_wk_logo.png';
import img_wising_logo from '../assets/img_wising_logo.svg';
import img_facebook from '../assets/img_facebook.svg';
import img_instagram from '../assets/img_instagram.svg';
import img_youtube from '../assets/img_youtube.svg';
import img_download_android from '../assets/img_download_android.png';
import img_download_ios from '../assets/img_download_ios.png';
import img_bluewave from '../assets/img_bluewave_desktop.png';
import { IOS_DOWNLOAD_URL, ANDROID_DOWNLOAD_URL, CONTACT_URL, COMPANY_PAGE } from '../data/url';

const Footer = () => {

    const scrollToAnchor = (anchor: string) => {
        const target = document.getElementById(anchor);
        target?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
       <div>
            <img src={img_bluewave} alt='img_bluewave' style={{ width: '100%', transform: 'translateY(6px)' }} />
            <Row align='top' style={{ backgroundColor: '#ECF4FD' }}>
                <Col md={6} sm={24} xs={24} style={{ textAlign: 'center' }}>
                    <img src={img_wk_logo} alt='img_wk_logo' style={{ height: '80px' }} />
                </Col>
                <Col md={1} sm={0} xs={0}></Col>
                <Col md={10} sm={24} xs={24}>
                    <Row>
                        <Col md={4} sm={24} xs={24} style={{ marginBottom: '20px', fontSize: '18px', lineHeight: '28px', textAlign:'center' }}><Link onClick={() => scrollToAnchor('feature')}>產品特色</Link></Col>
                        <Col md={4} sm={24} xs={24} style={{ marginBottom: '20px', fontSize: '18px', lineHeight: '28px', textAlign:'center' }}><Link onClick={() => scrollToAnchor('solution')}>企業方案</Link></Col>
                        <Col md={4} sm={24} xs={24} style={{ marginBottom: '20px', fontSize: '18px', lineHeight: '28px', textAlign:'center' }}><Link onClick={() => scrollToAnchor('case')}>企業案例</Link></Col>
                        <Col md={4} sm={24} xs={24} style={{ marginBottom: '20px', fontSize: '18px', lineHeight: '28px', textAlign:'center' }}><Link onClick={() => scrollToAnchor('faq')}>常見問題</Link></Col>
                        <Col md={4} sm={24} xs={24} style={{ marginBottom: '20px', fontSize: '18px', lineHeight: '28px', textAlign:'center' }}><Link href={CONTACT_URL} newTab>聯絡我們</Link></Col>
                        <Col md={4} sm={24} xs={24} style={{ marginBottom: '20px', fontSize: '18px', lineHeight: '28px', textAlign:'center' }}><Link href={COMPANY_PAGE} newTab>公司介紹</Link></Col>
                    </Row>
                    <Row>
                        <Col span={12} className='download-buttons'>
                            <Link href={IOS_DOWNLOAD_URL} newTab>
                                <img src={img_download_ios} alt='img_download_ios' className="download-button" />
                            </Link>
                        </Col>
                        <Col span={12} className='download-buttons'>
                            <Link href={ANDROID_DOWNLOAD_URL} newTab>
                                <img src={img_download_android} alt='img_download_android' className="download-button" />
                            </Link>
                        </Col>
                    </Row>
                </Col>
                <Col md={1} sm={0} xs={0}></Col>
                <Col md={6} sm={24} xs={24}>
                    <Row style={{ marginBottom: '20px' }}>
                        <Col md={0} sm={4} xs={4}/>
                        <Col md={4} sm={4} xs={4}>
                            <Link href='https://www.youtube.com/@Workute' newTab>
                                <img src={img_youtube} alt='img_youtube' />
                            </Link>
                        </Col>
                        <Col md={2} sm={2} xs={2}/>
                        <Col md={4} sm={4} xs={4}>
                            <Link href='https://www.facebook.com/Workute.tw/' newTab>
                                <img src={img_facebook} alt='img_facebook' />
                            </Link>
                        </Col>
                        <Col md={2} sm={2} xs={2}/>
                        <Col md={4} sm={4} xs={4}>
                            <Link href='https://www.instagram.com/Workute.tw/' newTab>
                                <img src={img_instagram} alt='img_instagram' />
                            </Link>
                        </Col>
                        <Col md={8} sm={4} xs={4}/>
                    </Row>
                    <Row className='company_info' style={{ marginBottom: '50px' }}>
                        <Col md={12} style={{ fontSize: '18px' }}>sales@wising.ai</Col>
                        <Col style={{ fontSize: '18px' }}>114 台北市內湖區瑞光路 335 號 3 樓</Col>
                        <Col style={{ fontSize: '18px' }}>
                            <Row align={'middle'}>
                            <img src={img_wising_logo} alt='img_wising_logo' style={{ height: '30px', marginBottom: '4px' }} />
                            <div style={{ fontSize: '18px' }}>緯詠智能股份有限公司</div></Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row style={{ height: '35px', backgroundColor:'white' }} justify='center' align='middle'>
                <div>© 2025 WiSING Smart Corporation. All Rights Reserved.</div>
            </Row>
       </div>
    )
};

export default Footer;
